import React from "react";
import EmptyData from "../../../../components/EmptyData";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { exams } from "../../../../api/exams";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { clearFlaggedQuestion } from "../../../../features/candidate-exam/candidate-exam-slice";
import { useTranslation } from 'react-i18next';

const Table = ({examHistory, search}) => {  
  const { t } = useTranslation();
  const {isLoading, mutateAsync} = useMutation(exams.retakeExam);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const retakeExam = async (examId, exam) => {
    if((exam?.number_of_attempts >= exam?.exam?.number_of_attempts_allowed) 
     // || !exam?.exam?.number_of_attempts_allowed || exam?.exam?.show_candidate_result
    ){
      return toast.error(t('max-attempts-reached'));
    }
    try {
      const response = await mutateAsync({examId, 
        userId: sessionStorage.getItem('user_id') || 
        JSON.parse(sessionStorage.getItem('user'))?.user?.user_id
      });
              if(response?.data?.redirect_to_results || response?.data?.show_candidate_result){
                return toast.error('You have reach the maximum attempt limit')
              }
               dispatch(clearFlaggedQuestion(null));
               sessionStorage.setItem("user_id", response?.data?.user?.user_id )
               window.sessionStorage.setItem("active-assessment-id", response?.data?.user?.exam_id);
               window.sessionStorage.setItem("active-assessment-user-id", response?.data?.user?.user_exam_id);
               window.sessionStorage.setItem("active-assessment", JSON.stringify(response?.data?.exam));
               window.sessionStorage.setItem("time_left", response?.data?.exam?.time_left);
               window.sessionStorage.setItem("duration", response?.data?.exam?.duration);
               window.sessionStorage.setItem("ql", response?.data?.exam?.number_of_questions);
               window.sessionStorage.setItem("starting-index", response?.data?.exam?.number_of_questions_answered);
              // navigate("/candidate/assessments/instructions");
              if(response?.data?.exam?.number_of_attempts) {
                sessionStorage.setItem('attempt_count', response?.data?.exam?.number_of_attempts)
              }  
              navigate(`/candidate/assessments/instructions`)
              sessionStorage.setItem('fromRoute', 'result')
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');

  return (
    <React.Fragment>
      <div style={{ border: "1px solid #ccc" }}>
        {examHistory.length ? (
          <div className="md:hidden mt-3 bg-white w-full p-4 rounded-md">
            {examHistory.map((exam, index) => (
              <ul className="border border-gray-300 rounded-lg mb-8 p-0" key={index}>
                <li className="flex justify-between py-3 px-4">
                  <span className="text-lg">{t('title')}:&nbsp;</span>
                  <span className="text-lg">{exam?.exam?.title}</span>
                </li>
                <li className="flex justify-between py-4 px-4">
                  <span className="text-lg">{t('client-name')}:&nbsp;</span>
                  <span className="text-lg">{exam?.exam?.client?.name}</span>
                </li>
                <li className="flex justify-between py-4 px-4">
                  <span className="text-lg">{t('status')}:&nbsp;</span>
                  <span className="text-lg">
                    {exam?.completed_at !== null ? (
                      <span className="bi bi-check2-circle text-green-500 text-2xl"></span>
                    ) : (
                      <span className="bi bi-x-octagon text-red-500 text-2xl"></span>
                    )}
                  </span>
                </li>
                <li className="flex justify-between py-4 px-4">
                  <span className="text-lg">{t('completed-at')}&nbsp;</span>
                  <span className="text-lg">
                    {`${new Date(exam?.completed_at).toLocaleDateString('EN-gb')}`}
                  </span>
                </li>
                <li className="flex justify-between py-4 px-4">
                  <span className="text-lg">{t('action')}&nbsp;</span>
                  <div className="flex flex-nowrap">
                    <button 
                    style={{ backgroundColor: brandedClient?.primary_colour || undefined}}
                      className="text-white bg-darkBlue mr-3 hover:bg-darkBlue-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center"
                      onClick={() => retakeExam(exam?.exam_id, exam)}
                    >
                      {isLoading ? t('loading') : t('retake-exam')}
                    </button>
                    {Boolean(exam?.exam?.show_candidate_result) ? (
                      <Link 
                        to={`/candidate/results/${exam?.exam_id}?userExamId=${exam?.user_exam_id}`}
                        className="text-white bg-primary hover:bg-primary-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center"
                        onClick={() => {
                          sessionStorage.setItem('activeExam', exam?.exam?.title)
                          sessionStorage.setItem('isAllowed', 
                            ( (exam?.number_of_attempts >= exam?.exam?.number_of_attempts_allowed)
                              || (!exam?.exam?.number_of_attempts_allowed) // || exam?.exam?.show_candidate_result
                            ) ? '0' : '1'
                          )
                          sessionStorage.setItem('attempt_count', exam?.number_of_attempts) 
                        }}
                      >
                        {t('view-result')}
                      </Link>
                    ) : (
                      <button 
                        className="bg-slate-200 hover:bg-slate-200-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center"
                        onClick={() => toast.error(t('result-not-available'))}
                      >
                        {t('view-result')}
                      </button>
                    )}
                  </div>
                </li>
              </ul>
            ))}
          </div>
        ) : (
          <section className="md:hidden">
            <EmptyData text={search !== '' ? t('no-search-results') : t('no-exam-history')} />
          </section>
        )}

        {examHistory.length ? (
          <div className="flex bg-white flex-col overflow-x-auto m-hidden">
            <div className="sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                <div className="overflow-x-auto">
                  <table className="min-w-full text-left text-sm font-light">
                    <thead className="border-b font-medium dark:border-neutral-500">
                      <tr>
                        <th scope="col" className="px-6 py-4">{t('serial-number')}</th>
                        <th scope="col" className="px-6 py-4">{t('title')}</th>
                        <th scope="col" className="px-6 py-4">{t('client-name')}</th>
                        <th scope="col" className="px-6 py-4">{t('status')}</th>
                        <th scope="col" className="px-6 py-4">{t('completed-at')}</th>
                        <th scope="col" className="px-6 py-4">{t('action')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {examHistory.length ? examHistory.map((exam, id) => (
                        <tr key={id} className="border-b dark:border-neutral-500">
                          <td className="whitespace-nowrap pl-8 pr-6 py-4 font-medium">{id + 1}</td>
                          <td className="whitespace-nowrap px-6 py-4">{exam?.exam?.title}</td>
                          <td className="whitespace-nowrap px-6 py-4">{exam?.exam?.client?.name}</td>
                          <td className="whitespace-nowrap px-6 py-4">
                            <span className="text-lg">
                              {exam?.completed_at !== null ? (
                                <span className="bi bi-check2-circle text-green-500 text-2xl"></span>
                              ) : (
                                <span className="bi bi-x-octagon text-red-500 text-2xl"></span>
                              )}
                            </span>
                          </td>
                          <td className="whitespace-nowrap px-6 py-4">
                            {`${new Date(exam?.completed_at).toLocaleDateString('EN-gb')}`}
                          </td>
                          <td className="whitespace-nowrap flex flex-nowrap py-4">
                            <button 
                            style={{ backgroundColor: brandedClient?.primary_colour || undefined}}
                              className="text-white bg-darkBlue mr-3 hover:bg-darkBlue-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center"
                              onClick={() => retakeExam(exam?.exam_id, exam)}
                            >
                              {t('retake-exam')}
                            </button>
                            {Boolean(exam?.exam?.show_candidate_result) ? (
                              <Link 
                                to={`/candidate/results/${exam?.exam_id}?userExamId=${exam?.user_exam_id}`}
                                className="text-white bg-primary hover:bg-primary-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center"
                                onClick={() => {
                                  sessionStorage.setItem('activeExam', exam?.exam?.title)
                                  sessionStorage.setItem('isAllowed', 
                                    ( (exam?.number_of_attempts >= exam?.exam?.number_of_attempts_allowed)
                                      || (!exam?.exam?.number_of_attempts_allowed) //||
                                      //(exam?.exam?.show_candidate_result)
                                    ) ? '0' : '1'
                                  )
                                  sessionStorage.setItem('attempt_count', exam?.number_of_attempts) 
                                }}
                              >
                                {t('view-result')}
                              </Link>
                            ) : (
                              <button 
                                className="bg-slate-200 hover:bg-slate-200-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center"
                                onClick={() => toast.error(t('result-not-available'))}
                              >
                                {t('view-result')}
                              </button>
                            )}
                          </td>
                        </tr>
                      )) : null}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <section className="max-[500px]:hidden">
            <EmptyData text={search !== '' ? t('no-search-results') : t('no-exam-history')} />
          </section>
        )}
      </div>
    </React.Fragment>
  );
};

export default Table;
